import React, { useState, useContext} from 'react';
import {
  SafeAreaView,
  StyleSheet,
  View,
  Text,
  TextInput,
  Button,
  Image,
  Alert,
  TouchableOpacity,
  Modal,
  ScrollView,
} from 'react-native';
import { AuthContext } from '../Contexts/ContextUsuario'
import { ProductsContext } from '../Contexts/ContextProdutos';


const TelaEnviado = (props) => {
  const { state, actions } = useContext(AuthContext);
  const { estado } = useContext(ProductsContext);

  estado.cart.products = []

  return (
    <View style={Style.layout}>
      <View style={Style.centeredView}>
        <Text style={Style.textStyle}> Pedido Enviado! </Text>
        <Text style={Style.numStyle}> O Nº do pedido é {state.user.numpedido} </Text>
        <TouchableOpacity
          style={Style.botão}
          onPress={() => props.navigation.navigate('LOGIN')}>
            <Text style={Style.textoBotao}> Voltar ao início </Text>
        </TouchableOpacity>
      </View>
      <View style={Style.LogoLayout}>
        <Image
          style={Style.LogoMarista}
          source={{uri: 'https://cdn.discordapp.com/attachments/804330188602605588/809404527412248576/logo_marista_a.png'}}
        />
      </View>
    </View>
  );
}
const Style = StyleSheet.create({
  centeredView: {
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '60%',
    margin: 20,
    height: '20%',
    backgroundColor:  'rgba(0, 58, 109, 255)',
    borderRadius: 20,
  },

  layout: {
    width: '100%',
    height: '100%',

    backgroundColor: 'rgba(179, 179, 179, 255)',
  },

  textStyle: {
    color: 'white',
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: 25,
    marginTop: 20,
  },
  numStyle: {
    color: 'white',
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: 22,
    marginTop: 0,
  },
  textoBotao: {
    color: 'black',
    fontWeight: 'normal',
    textAlign: 'center',
    fontSize: 17,
    marginTop: 0,
  },

  botão: {
    backgroundColor: 'rgba(255, 255, 255, 255)',
    borderRadius: 20,
    padding: 11,
    marginBottom: 30,
    marginTop: 20,
    marginHorizontal: 0,

  },

  LogoMarista: {
    height: 75,
    width: 320,

    marginTop: '60%',
  },

  LogoLayout: {
    justifyContent: 'center',
    alignItems: 'center',
  },
});


export default TelaEnviado;